import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAvailableColumns } from './api';

export const path = '/survey-acts';

const PageMySurveyActs: React.FC = (props) => {
  const MySurveyActs = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...props} columns={loaded.columns} />;
    },
  });

  return <MySurveyActs />;
};

export default PageMySurveyActs;
